import { SB } from '@play-co/replicant';
import { petAttributes, petStatusEffects } from '../buruburu/pet/pet.ruleset';

export const visitSchema = {
  visit: SB.object({
    // Track data about current visit session
    visitSession: SB.object({
      // name of player currently being visited
      name: SB.string(),

      // name of friend's pet
      petName: SB.string(),

      // id of player currently being visited
      friendId: SB.string(),

      // Number of care actions completed during the visit
      careActions: SB.number(),

      // Number of conversation dialogs started during the visit
      friendDialogs: SB.number(),

      // Number of gems granted by the friend's pet during the visit
      gemsReceived: SB.number(),

      // Number of coins spent during the visit
      coinsSpent: SB.number(),

      // Current evolution of the friend's pet
      currentEvolution: SB.object({
        species: SB.string(),
        stage: SB.string(),
      }),

      // Answers to the friend's pet's conversation
      answers: SB.map(
        SB.object({
          key: SB.string().optional(),
          value: SB.string(),
        }),
      ),

      // Last known state of friend's pet
      unsyncedChanges: SB.object({
        attributes: SB.object(
          petAttributes.reduce(
            (acc, cur) => ({ ...acc, [cur]: SB.number().optional() }),
            {},
          ),
        ),
        statusEffects: SB.object(
          petStatusEffects.reduce(
            (acc, cur) => ({ ...acc, [cur]: SB.boolean().optional() }),
            {},
          ),
        ),
      }),

      isKickedOut: SB.boolean().optional(),
    }).optional(),

    // Amount of gem grants received today.
    gemsGrantsToday: SB.number(),

    // Time of last gem grant.
    lastGemsGrantAt: SB.number(),

    // Map of player ids to count of times visiting player
    visits: SB.map(
      SB.object({
        count: SB.number(),
        lastUpdatedAt: SB.number(),
        lastGemsGrantAt: SB.number(),
      }),
    ),

    // Map of player ids to count of times being visited by player
    visited: SB.map(
      SB.object({
        name: SB.string(),
        count: SB.number(),
        lastUpdatedAt: SB.number(),
      }),
    ),

    // Gems not yet granted to player.
    pendingGemsGrants: SB.number().default(0),
  }),
  platform: SB.string().optional(),
};
